import script from "./VendorOnboard.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorOnboard.vue?vue&type=script&setup=true&lang=js"

import "./VendorOnboard.vue?vue&type=style&index=0&id=00d801b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00d801b0"]])

export default __exports__